// drive 文件描述符信息
export var FILE_DESC = '/v2/drive/file/desc';
export var PREVIEW_INFO = '/v2/drive/docsPreviewURL';
export var PREVIEW_QUERY = '/v2/drive/preview/query';
export var DOWNLOAD_INFO = '/v2/drive/downloadURL';
export var COPY_INFO = '/v2/file/clone';
export var IMPORT_FILE = '/v1/import/file';
